interface ApplyV2Error {
    code: number;
    message: string;
    field: string | undefined | null;
}

function isHasSomeError1201Code(error: {
    data?: {
        errors?: ApplyV2Error[]
    }
} | any) {
    if (error?.data?.errors && Array.isArray(error?.data?.errors)) {
        const errorMessages = error?.data?.errors || []
        return errorMessages.some(({ code }) => code === 1201)
    } else {
        return false
    }

}

export default isHasSomeError1201Code;
